import { IdentityWithoutIds } from '../base/identity';

export class HorseRoleIdentityWithoutIds extends IdentityWithoutIds {

    constructor(params?: Partial<HorseRoleIdentityWithoutIds>) {
        super(params);
    }

}
